import { Component, computed, inject, input, ChangeDetectionStrategy } from '@angular/core';

import { ButtonComponent, TextHtmlComponent } from '@sirius/common';
import { TranslateModule } from '@ngx-translate/core';
import { MatchmakingDataService, MatchmakingTranslateService } from 'matchmaking/services';
import { InterpolatePipe } from 'shared/pipes';


@Component({
    selector: 'matchmaking-form-step-header-wrapper',
    imports: [TranslateModule, InterpolatePipe, ButtonComponent, TextHtmlComponent],
    templateUrl: './form-step-header-wrapper.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './form-step-header-wrapper.component.scss'
})
export class FormStepHeaderWrapperComponent {
    private translationService = inject(MatchmakingTranslateService);
    private dataService = inject(MatchmakingDataService);

    title = input<string | null>('');
    description = input<string | null>('');
    step = input.required<number>();
    lastStep = input.required<boolean>();

    industry = computed(() => this.dataService.selectedIndustryTitle());
    application = computed(() => this.dataService.selectedApplicationTitle());
    translations = computed(() => this.translationService.translations());

    public readonly STEP_THRESHOLD_INDUSTRY = 1;
    public readonly STEP_THRESHOLD_APPLICATION = 2;

    public anchorClickEvent() {
        const element = document.getElementById('contact-form');
        if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }
}
